{
  "groups": {
    "referenceNumber": "참조 번호",
    "appointmentStartTimes": "예약 시작 시간",
    "appointmentNotifications": "예약 알림",
    "appointmentStatuses": "예약 상태",
    "customAppointmentsGrid": "사용자 지정 예약 그리드",
    "limiter": "한도 제한",
    "schedulingPortal": "예약 포털",
    "dockSelection": "도크 선택",
    "timeDisplay": "시간 표시",
    "gateManagement": "게이트 관리",
    "smartGate": "SmartGate",
    "idValidation": "신원 확인",
    "appointmentValidation": "예약 검증",
    "other": "기타",
    "handlingUnits": "취급 단위"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "참조 번호는 운송사가 예약할 때 요청할 수 있는 참조 정보입니다.",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "예약을 시작할 수 있는 시간 간격을 설정합니다.",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "이 {entity}의 모든 유형의 예약 알림을 관리합니다.",
    "manageTheSchedulingPortalSettingsForThisEntity": "이 {entity}의 예약 포털 설정을 관리합니다",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "취급 단위는 예약 시 단위(예: 팔레트)를 요청하기 위한 숫자 필드입니다. 양식에 추가하면 한도 제한 기능도 사용할 수 있습니다.",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "한도 제한을 사용하면 하루에 예약할 수 있는 예약 또는 취급 단위(예: 팔레트)의 최대 수를 설정할 수 있습니다."
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "최소 참조 번호 수",
    "maximumAmountOfReferenceNumbers": "최대 참조 번호 수",
    "includeReferenceNumberFieldOnAllAppointmentForms": "모든 예약 양식에 참조 번호 필드를 포함하시겠습니까?",
    "referenceNumberFieldName": "참조 번호 필드 이름",
    "referenceNumberHelperText": "참조 번호 도움말 텍스트",
    "makeReferenceNumberARequiredField": "참조 번호를 필수 필드로 지정하시겠습니까?",
    "allowAppointmentsForThisEntityToStartAt": "이 {entity}의 예약 시작 허용 시간:",
    "enableAppointmentNotificationsForThisEntity": "이 {entity}의 예약 알림을 사용하시겠습니까?",
    "selectEachDesiredStartTimeIndividually": "원하는 시작 시간을 개별적으로 선택하세요",
    "hideTheLoadTypeDuration": "화물 유형 소요 시간을 숨기시겠습니까?",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "{entity} 로고를 업로드하여 예약 포털과 모든 이메일 알림에 표시하세요",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "창고 야드 지도를 업로드하여 예약 포털에 표시하세요",
    "statusForNewlyCreatedAppointments": "새로 생성된 예약의 상태",
    "muteAppointmentNotifications": "예약 알림 음소거",
    "allowDockSelectionInSchedulingPortal": "예약 포털에서 도크 선택을 허용하시겠습니까?",
    "theStatusThatFollowsArrivedIs": "'도착함' 다음 상태",
    "displayTimeIn": "시간 표시 형식:",
    "customizeAppointmentDetails": "예약 세부 정보 사용자 지정",
    "gridTileConfig": "그리드 타일 구성",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "지오펜싱을 적용하여 운전자에게 실시간 위치 제공 요구",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "운전자가 체크인한 후 추가 정보를 표시하시겠습니까? (선택 사항)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "예약 포털에서 예약 일정 변경을 막으시겠습니까?",
    "revertToRequestedOnCarrierReschedule": "운송사가 일정 변경 시 요청됨 상태로 되돌리기",
    "observationMatchAttribute": "관측 매칭 속성",
    "observationMatchTimeWindow": "관측 매칭 시간 범위",
    "autoDepartAssets": "자산 자동 출발 처리",
    "autoCreateAssets": "자산 자동 생성",
    "gateFeedColumns": "Gate Feed 열",
    "checkInEarlyThreshold": "체크인 조기 허용 기준",
    "checkInLateThreshold": "체크인 지각 허용 기준",
    "technicalContactEmailAddress": "기술 담당자 이메일 주소",
    "technicalContactEmailThrottleMinutes": "기술 담당자 이메일 발송 간격(분)",
    "requireUniqueReferenceNumbers": "고유한 참조 번호 필수",
    "appointmentStartTimeInterval": "예약 시작 시간 간격",
    "referenceNumberInputMode": "참조 번호 입력 모드",
    "uploadWarehouseYardMap": "창고 야드 지도를 업로드하여 예약 포털에 표시하세요",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "모든 예약 양식에 취급 단위 필드를 포함하시겠습니까?",
    "handlingUnitsLabel": "취급 단위 레이블",
    "handlingUnitsHelperText": "취급 단위 도움말 텍스트",
    "makeHandlingUnitsARequiredField": "취급 단위를 필수 필드로 지정하시겠습니까?",
    "maximumHandlingUnitsValueForAnAppointment": "예약당 최대 취급 단위 값",
    "minimumHandlingUnitsValueForAnAppointment": "예약당 최소 취급 단위 값",
    "checkOutBolSignedRequired": "체크아웃 시 BOL 서명 필수",
    "checkOutBolNotLoadingErrorMessage": "체크아웃 BOL 로드 실패 시 오류 메시지",
    "checkOutIdentifier": "체크아웃 식별자",
    "enableCheckInIdValidationPersona": "체크인 신원 확인 사용(Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "체크인 완료를 위해 체크인 신원 확인 필수",
    "checkInIdValidationTemplate": "체크인 신원 확인 템플릿",
    "geofenceRadius": "지오펜스 반경",
    "createAppointmentOnExternalValidationFailure": "외부 검증 실패 시에도 예약 생성",
    "enableOverrideLimiterFunction": "한도 제한 무시 기능 사용",
    "receiveUnplannedCheckInEmailNotifications": "예정되지 않은 체크인 이메일 알림 받기",
    "driversMustEnterAReferenceNumberToCheckIn": "운전자는 체크인하려면 참조 번호를 입력해야 합니다",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "참조 번호가 예약과 일치하는 경우에만 운전자가 체크인할 수 있습니다",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "운전자는 체크인 시 참조 번호 단계를 건너뜁니다",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "운전자가 체크인 후 받는 첫 번째 SMS 메시지 사용자 지정(선택 사항)",
    "includeYardMapImageInTheFirstCheckInSms": "첫 번째 체크인 SMS에 야드 지도 이미지를 포함하시겠습니까?",
    "automaticallyDeleteStoredIdValidations": "저장된 신원 확인 자동 삭제",
    "deleteStoredIdValidationsAfter": "저장된 신원 확인 삭제 기한",
    "displayDatesAs": "날짜 표시 형식:",
    "displayTimeAs": "시간 표시 형식:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "예약에 최소 이 개수 이상의 참조 번호를 요구합니다",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "예약에 최대 이 개수까지의 참조 번호를 허용합니다",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "참조 번호 필드의 표시 이름입니다. 예: \"PO 번호\", \"배송 ID\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "참조 번호 필드 입력에 도움이 되는 추가 정보입니다. 예: \"참조 번호는 OD-XX로 시작해야 합니다\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "모든 예약에 참조 번호를 필수로 요구합니다",
    "thisOnlyAffectsNewlyCreatedAppointments": "새로 생성된 예약에만 적용됩니다",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "예약 포털에서 예약할 때 화물 유형 선택 목록에 소요 시간이 표시됩니다",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "예약 포털에서 예약할 때 도크 선택을 허용합니다",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "이 설정을 사용하면 '도착함'과 '완료됨' 사이에 '진행 중' 상태를 선택할 수 있습니다",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "예약 그리드 및 보고서를 포함하여 플랫폼 전체에서 이 조직의 모든 사용자에게 시간이 표시되는 방식을 설정합니다.",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "사용하면 새로운 사용자 지정 예약 세부 정보 시스템으로 전환됩니다",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "그리드 타일 표시 방식에 대한 사용자 구성입니다.",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "이 설정은 운전자의 위치를 요청하며, 창고에서 1마일 이상 떨어져 있으면 체크인을 제한합니다.",
    "preventCarriersFromReschedulingAppointmentsOptional": "운송사가 예약 일정을 변경하지 못하도록 합니다. (선택 사항)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "운송사가 예약됨 상태의 예약 일정을 변경하면 재승인을 위해 요청됨 상태로 되돌립니다",
    "attributeToBeUsedForMatchingObservations": "관측 매칭에 사용할 속성",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "체크인 시간 전후로 관측을 인정할 시간(분)",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "운송사가 예약 시작 시간 몇 분 전부터 체크인할 수 있는지 설정합니다",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "운송사가 예약 시작 시간 몇 분 후까지 체크인할 수 있는지 설정합니다",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "기술 문제 및 정보를 받을 이메일 주소",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "검증 서버 오류 발생 시 기술 담당자에게 보내는 알림 사이의 간격입니다.",
    "aListOfMutedAppointmentNotifications": "음소거된 예약 알림 목록입니다.",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "모든 예약에 고유한 참조 번호를 요구합니다",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "예약을 시작할 수 있는 시간 사이의 간격(분)입니다",
    "enableTheCustomAppointmentStartTimesSetting": "사용자 지정 예약 시작 시간 설정을 사용합니다",
    "theInputModeForTheReferenceNumberField": "참조 번호 필드의 입력 모드",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "단위 유형 필드의 표시 이름입니다. 예: 팔레트 수, 스키드 수",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "모든 예약에 단위 유형 필드를 필수로 요구합니다",
    "autoDepartAssetsOnReceivingOutgateEvent": "출문 이벤트 수신 시 자산을 자동으로 출발 처리합니다",
    "autoCreateAssetsOnReceivingIngateEvent": "입문 이벤트 수신 시 자산을 자동으로 생성합니다",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "AI Gate Feed 페이지에서 사용할 수 있는 열입니다. 필수 열은 항상 표시됩니다.",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "예약 검증을 통과하지 못해도 예약을 생성합니다",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "운전자가 체크인하기 위해 있어야 하는 반경(마일)입니다. 지오펜싱이 사용 설정된 경우에만 적용됩니다.",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "단위 유형 필드 입력에 도움이 되는 추가 정보입니다. 예: 단위 유형은 숫자만 입력해야 합니다",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "예약의 취급 단위 필드에 입력할 수 있는 최대 숫자 값을 설정합니다",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "예약의 취급 단위 필드에 입력할 수 있는 최소 숫자 값을 설정합니다",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "한도 제한이 100%에 도달하면, 이 기능을 통해 창고 사용자만 한도를 무시하고 예약 및 단위를 생성하거나 승인할 수 있습니다",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "시스템이 체크아웃 양식을 검증하는 데 사용할 자산 속성",
    "enforceBolSigningOnCheckOutForm": "체크아웃 양식에서 BOL 서명을 필수로 적용합니다",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "BOL을 사용할 수 없으면 운송사가 서명할 수 없으므로 체크아웃이 차단됩니다. 이런 경우 운전자에게 표시할 사용자 지정 안내를 여기에서 설정할 수 있습니다.",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "신원 확인을 위해 체크인 흐름에 Persona 구성 요소를 표시합니다",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "운전자가 체크인을 완료하기 전에 Persona 검증 성공을 요구합니다",
    "personaTemplateUsedForCheckInIdentityVerification": "체크인 신원 확인에 사용되는 Persona 템플릿",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "예정되지 않은 체크인이 발생하면 창고 수신자가 이메일 알림을 받습니다",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "이 메시지는 운전자에게 SMS로 전송되는 기본 체크인 확인 문구를 대체합니다. 기본 메시지를 사용하려면 비워 두세요.",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "체크인 SMS 직후 야드 지도를 별도의 이미지 메시지로 보냅니다. 이 창고에 야드 지도가 업로드되어 있어야 합니다.",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "저장된 신원 확인 기록은 보존 기간이 지나면 영구적으로 삭제됩니다",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "저장된 신원 확인을 삭제하기 전까지 보관하는 일수",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "회사용 화면 전반에서 이 회사 사용자에게 날짜가 표시되는 방식을 설정합니다.",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "회사용 화면 전반에서 이 회사 사용자에게 시간이 표시되는 방식을 설정합니다."
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "예약과 연결된 참조 번호",
    "insertMessageHere": "여기에 메시지를 입력하세요"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "정각(:00)",
      "topAndBottomOfTheHour00And30": "정각 및 30분(:00, :30)",
      "everyTwentyMinutes0020And40": "20분마다(:00, :20, :40)",
      "everyQuarterOfTheHour001530And45": "15분마다(:00, :15, :30, :45)",
      "customStartTimes": "사용자 지정 시작 시간"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15분",
      "30Minutes": "30분",
      "60Minutes": "60분",
      "90Minutes": "90분"
    },
    "observationMatchAttribute": {
      "licensePlate": "번호판",
      "dotNumber": "DOT 번호",
      "any": "모두",
      "cascade": "순차 적용"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "영숫자",
      "numeric": "숫자"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "예약됨",
      "requested": "요청됨"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "진행 중",
      "completed": "완료됨"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "아니요, 참조 번호 필드를 포함하지 않습니다",
      "yesIncludeTheReferenceNumberField": "예, 참조 번호 필드를 포함합니다"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "아니요, 화물 유형 소요 시간을 숨기지 않습니다",
      "yesHideTheLoadTypeDuration": "예, 화물 유형 소요 시간을 숨깁니다"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "아니요, 예약 알림을 사용하지 않습니다",
      "yesEnableAppointmentNotifications": "예, 예약 알림을 사용합니다"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "아니요, 도크 선택을 허용하지 않습니다",
      "yesAllowTheDockSelection": "예, 도크 선택을 허용합니다"
    },
    "displayTimeIn": {
      "regularTime12Hour": "일반 시간(12시간제)",
      "militaryTime24Hour": "24시간제"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "예약 포털에서 일정 변경 허용 ",
      "preventReschedulingInTheSchedulingPortal": "예약 포털에서 일정 변경 금지"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "운송사가 일정 변경 시 요청됨 상태로 되돌리기",
      "keepStatusUnchangedOnCarrierReschedule": "운송사가 일정 변경 시 상태 유지"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "아니요, 참조 번호를 필수 필드로 지정하지 않습니다",
      "yesMakeReferenceNumberARequiredField": "예, 참조 번호를 필수 필드로 지정합니다"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "아니요, 고유한 참조 번호를 요구하지 않습니다",
      "yesRequireUniqueReferenceNumbers": "예, 고유한 참조 번호를 요구합니다"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "아니요, 취급 단위를 필수 필드로 지정하지 않습니다",
      "yesMakeHandlingUnitsARequiredField": "예, 취급 단위를 필수 필드로 지정합니다"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "아니요, 취급 단위 필드를 포함하지 않습니다",
      "yesIncludeTheHandlingUnitsField": "예, 취급 단위 필드를 포함합니다"
    },
    "checkOutIdentifier": {
      "licensePlate": "번호판",
      "phoneNumber": "전화번호",
      "any": "모두"
    },
    "enableCheckInIdValidationPersona": {
      "no": "아니요",
      "yes": "예"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "아니요",
      "yes": "예"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "운전면허증 - 앞면 - 재시도 1회",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "운전면허증 - 앞면, 바코드, 얼굴, 미국 전용, 재시도 1회"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "아니요",
      "yes": "예"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/YYYY",
      "ddMmYyyy": "DD/MM/YYYY",
      "yyyyMmDd": "YYYY-MM-DD",
      "tueMmDdYyyy": "화, MM/DD/YYYY",
      "tueDdMmYyyy": "화, DD/MM/YYYY",
      "tueYyyyMmDd": "화, YYYY-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12시간제(예: 오전 7:00)",
      "24HourEG0700": "24시간제(예: 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "예: 오전 7:00 / 오후 7:00",
      "eG07001900": "예: 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "참고:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "비워 두면 기본 이름이 적용됩니다",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "비워 두면 기본 도움말 텍스트가 적용됩니다",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "이 옵션을 사용해도 예약별로 이미 개별 해제된 알림에는 영향을 주지 않습니다.",
    "ifLeftEmptyNoNotificationsWillBeSent": "비워 두면 알림이 전송되지 않습니다",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "취소되었거나 노쇼 처리된 예약에 할당된 참조 번호는 새 예약에 재사용할 수 있습니다",
    "ifEmptyTheDefaultNameWillBeApplied": "비어 있으면 기본 이름이 적용됩니다"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "운전자",
    "checkInSms": "체크인 SMS",
    "dataRetention": "데이터 보존"
  }
}
